import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Row, Col, InputNumber, Spin, Select, DatePicker, Checkbox, Button, message } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';
import Logo from './img/logo.png';
import { monthsOptions } from './utils/globals';

import CollegesQuery from './graphql/queries/collegesQuery.graphql';
import CreateEdlApplicationMutation from './graphql/mutations/createEdlApplicationMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 10 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 10 },
    xl: { span: 10 },
    xxl: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 14 },
    sm: { span: 14 },
    md: { span: 14 },
    lg: { span: 14 },
    xl: { span: 14 },
    xxl: { span: 14 },
  },
};

const additionalInfoFormItemLayout = {
  labelCol: {
    xs: { span: 10 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 6 },
    xl: { span: 6 },
    xxl: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 14 },
    sm: { span: 14 },
    md: { span: 14 },
    lg: { span: 18 },
    xl: { span: 18 },
    xxl: { span: 18 },
  },
};

const cobRelationshipOptions = [
  { name: 'Father', value: 'father' },
  { name: 'Mother', value: 'mother' },
  { name: 'Brother', value: 'brother' },
  { name: 'Sister', value: 'sister' },
  { name: 'Spouse', value: 'spouse' },
  { name: 'Cousin', value: 'cousin' },
  { name: 'Paternal Uncle (Chacha)', value: 'paternalUncle' },
  { name: 'Paternal Aunt (Chachi)', value: 'paternalAunt' },
  { name: 'Maternal Uncle (Mama)', value: 'maternalUncle' },
  { name: 'Maternal Aunt (Mami)', value: 'maternalAunt' },
  { name: 'Relative', value: 'relative' },
];

const professionOptions = [
  { name: 'Salaried - Pvt Ltd/Partnership', value: 'salariedPrivate' },
  { name: 'Salaried - Govt/Pul Ltd/Pub sector', value: 'salariedPublic' },
  { name: 'Salaried - MNC', value: 'salariedMnc' },
  { name: 'Self Emp - Partnership/Proprietorship', value: 'selfEmpPropPartner' },
  { name: 'Self Emp - Pvt Ltd', value: 'selfEmpPvtLtd' },
  { name: 'Farmer', value: 'farmer' },
  { name: 'Retired', value: 'retired' },
  { name: 'Other', value: 'other' },
];

const collateralOptions = [
  { name: 'Flat', value: 'flat' },
  { name: 'House', value: 'house' },
  { name: 'Non-Agricultural Land', value: 'naLand' },
  { name: 'FD', value: 'fd' },
];

class App extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const valuesToSubmit = { ...values };
        if (valuesToSubmit.cobDob) valuesToSubmit.cobDob = valuesToSubmit.cobDob.format('YYYY-MM-DD');
        mutate({ variables: valuesToSubmit })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            message.success('Application submitted!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form, data } = this.props;
    const { getFieldDecorator, getFieldValue } = form;

    const { loading } = data;
    if (loading) return <Spin size="large" />;

    const { colleges } = data;

    const selectedCollegeId = getFieldValue('edlCollegeId');
    let courseOptions = [];
    if (selectedCollegeId) {
      courseOptions = colleges
        .find((entry) => entry.id === selectedCollegeId)
        .courses.map((entry) => ({
          name: `${entry.name} (${entry.durationYears} years)`,
          value: entry.id,
        }));
    }

    const currentYear = new Date().getFullYear();

    return (
      <div>
        <div className="header">
          <img src={Logo} alt="Logo" />
          <h2 style={{ width: '100%', margin: 0, textAlign: 'center' }}>Bizminder Education Loans</h2>
        </div>
        <div className="contentBox" style={{ margin: 20 }}>
          <div style={{ width: 860, margin: 'auto' }}>
            <p>
              Please complete the online form below, to get education loan for Bizminder&apos;s associated colleges.
            </p>
            <Form id="loanApplicationForm" onSubmit={this.handleSubmit}>
              <div className="applicationFormSectionHeader">A. Student Details</div>
              <div className="applicationFormSection">
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="First Name" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('firstName', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Last Name" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('lastName', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Current Address" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('currentAddress.streetAddress', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<TextArea autosize={{ minRows: 3, maxRows: 6 }} disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="City" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('currentAddress.city', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="State" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('currentAddress.state', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Pincode" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('currentAddress.pincode', {
                        rules: [
                          { required: true, message: 'Field is required!' },
                          { pattern: validationRegex.pincode, message: 'Incorrect value' },
                        ],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Mobile" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('mobile', {
                        rules: [
                          { required: true, message: 'Field is required!' },
                          { pattern: validationRegex.mobile, message: 'Incorrect value' },
                        ],
                      })(<Input required addonBefore="+91" disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Email" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('email', {
                        rules: [
                          { required: true, message: 'Field is required!' },
                          { type: 'email', message: 'Incorrect value' },
                        ],
                      })(<Input required disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Last College / University Attended" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('lastCollege', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input required disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Name of the last course completed" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('lastCourse', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input required disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Percent marks obtained in the last course" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('lastCourseMarksPercent', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<InputNumber min={1} max={100} required disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <div className="applicationFormSectionHeader">B. Course Details for Which Loan is Needed</div>
              <div className="applicationFormSection">
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="College" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('edlCollegeId', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(
                        <Select disabled={submittingForm} showSearch placeholder="Select college">
                          {colleges.map((entry) => (
                            <Option key={entry.id} value={entry.id}>
                              {entry.name} ({entry.city})
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Course" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('edlCourseId', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(
                        <Select
                          disabled={submittingForm || courseOptions.length === 0}
                          showSearch
                          placeholder="Select course"
                        >
                          {courseOptions.map((entry) => (
                            <Option key={entry.value} value={entry.value}>
                              {entry.name}
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="When loan is required?" {...formItemLayout}>
                      <Row>
                        <Col span={12}>
                          {getFieldDecorator('loanRequiredMonth', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(
                            <Select disabled={submittingForm} placeholder="Month">
                              {monthsOptions.map((entry) => (
                                <Option key={entry.value} value={entry.value}>
                                  {entry.name}
                                </Option>
                              ))}
                            </Select>,
                          )}
                        </Col>
                        <Col span={12}>
                          {getFieldDecorator('loanRequiredYear', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(
                            <Select disabled={submittingForm} placeholder="Year">
                              <Option value={currentYear}>{currentYear}</Option>
                              <Option value={currentYear + 1}>{currentYear + 1}</Option>
                            </Select>,
                          )}
                        </Col>
                      </Row>
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Loan amount in rupees" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('loanAmount', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<InputNumber required disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <div className="applicationFormSectionHeader">C. Co-borrower Details</div>
              <div className="applicationFormSection">
                <p style={{ fontSize: 12 }}>
                  <strong>Co-borrower</strong> - Relative with good income who can support your education loan
                  application. Typically it can be your Father, Mother, Brother, Sister, Spouse, Cousin, Paternal Uncle
                  (Chacha), Paternal Aunt (Chachi), Maternal Uncle (Mama), Maternal Aunt (Mami), Grandfather,
                  Grandmother
                </p>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Relationship with the student" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobRelationship', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(
                        <Select disabled={submittingForm} showSearch placeholder="Select one">
                          {cobRelationshipOptions.map((entry) => (
                            <Option key={entry.value} value={entry.value}>
                              {entry.name}
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="First Name" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobFirstName', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Last Name" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobLastName', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Current Address" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobCurrentAddress.streetAddress', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<TextArea autosize={{ minRows: 3, maxRows: 6 }} disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="City" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobCurrentAddress.city', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="State" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobCurrentAddress.state', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Pincode" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobCurrentAddress.pincode', {
                        rules: [
                          { required: true, message: 'Field is required!' },
                          { pattern: validationRegex.pincode, message: 'Incorrect value' },
                        ],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Date of Birth" {...formItemLayout}>
                      {getFieldDecorator('cobDob')(<DatePicker disabled={submittingForm} format="Do MMM, YYYY" />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Email" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobEmail', {
                        rules: [{ type: 'email', message: 'Incorrect value' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Mobile" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobMobile', {
                        rules: [
                          { required: true, message: 'Field is required!' },
                          { pattern: validationRegex.mobile, message: 'Incorrect value' },
                        ],
                      })(<Input required addonBefore="+91" disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Landline (with STD code)" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobLandline', {
                        rules: [{ pattern: validationRegex.landline, message: 'Incorrect value' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Profession of co-borrower" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobProfession', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(
                        <Select disabled={submittingForm} showSearch placeholder="Select one">
                          {professionOptions.map((entry) => (
                            <Option key={entry.value} value={entry.value}>
                              {entry.name}
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Designation of co-borrower" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobDesignation', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col span={12}>
                    <FormItem label="Name of employer / company" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobCompanyName', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<Input disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Net monthly income (rupees)" hasFeedback {...formItemLayout}>
                      {getFieldDecorator('cobMonthlyIncome', {
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(<InputNumber disabled={submittingForm} />)}
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <div className="applicationFormSectionHeader">D. Collateral Security Details</div>
              <div className="applicationFormSection">
                <p style={{ fontSize: 12 }}>
                  <strong>Collateral</strong> - Security which can support your loan amount is a collateral. It can be a
                  Flat, House, Non-agricultural Land, Fixed Deposit, etc. Sufficient and good collateral security
                  improves loan application significantly.
                </p>
                <Row gutter={10}>
                  <Col span={16}>
                    <FormItem label="Can offer Collateral Security" {...formItemLayout}>
                      {getFieldDecorator('collateralOffered', {
                        initialValue: false,
                        rules: [{ required: true, message: 'Field is required!' }],
                      })(
                        <Checkbox required disabled={submittingForm}>
                          Select if collateral security can be offered
                        </Checkbox>,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                {getFieldValue('collateralOffered') ? (
                  <Fragment>
                    <Row gutter={10}>
                      <Col span={12}>
                        <FormItem label="Type of collateral" hasFeedback {...formItemLayout}>
                          {getFieldDecorator('collateralType', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(
                            <Select disabled={submittingForm} placeholder="Select one">
                              {collateralOptions.map((entry) => (
                                <Option key={entry.value} value={entry.value}>
                                  {entry.name}
                                </Option>
                              ))}
                            </Select>,
                          )}
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem label="Market value of collateral (rupees)" hasFeedback {...formItemLayout}>
                          {getFieldDecorator('collateralMarketValue', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(<InputNumber disabled={submittingForm} />)}
                        </FormItem>
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col span={12}>
                        <FormItem label="City where collateral located" hasFeedback {...formItemLayout}>
                          {getFieldDecorator('collateralLocationCity', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(<Input disabled={submittingForm} />)}
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem label="State where collateral located" hasFeedback {...formItemLayout}>
                          {getFieldDecorator('collateralLocationState', {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(<Input disabled={submittingForm} />)}
                        </FormItem>
                      </Col>
                    </Row>
                  </Fragment>
                ) : null}
              </div>

              <div className="applicationFormSectionHeader">E. Additional Information</div>
              <div className="applicationFormSection">
                <Row gutter={10}>
                  <Col span={24}>
                    <FormItem label="Additional Information" {...additionalInfoFormItemLayout}>
                      {getFieldDecorator('additionalInformation')(
                        <TextArea autosize={{ minRows: 3, maxRows: 6 }} disabled={submittingForm} />,
                      )}
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <FormItem style={{ marginTop: 20 }}>
                <Button type="primary" htmlType="submit" loading={submittingForm} size="large">
                  Submit
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
    getFieldValue: PropTypes.func,
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    colleges: PropTypes.array,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default compose(
  graphql(CreateEdlApplicationMutation),
  graphql(CollegesQuery),
  Form.create(),
)(App);



// WEBPACK FOOTER //
// ./src/App.jsx